module.exports = __webpack_public_path__ + "img/icon-xing-guide.9b38c058.svg";